import React from "react";
import {
  AmountData,
  CreateTradeSections,
  ErrorsData,
  TradeFormSetters,
  TradeFormValues,
  TradingTerminalTabs,
} from "@shared/features/tradingTerminal/common/types";
import {
  AvailableQuantityResponse,
  CreateSignalRequest,
  CreateTradeRequest,
  GetCreateSignalOrTradeGeneralDataResponse,
  GetCreateTradeGeneralDataResponse,
  GetSignalCreateGeneralDataResponse,
  GroupData,
  QueryStatus,
  SubGroup,
} from "@shared/types";

export const TradingTerminalContext = React.createContext<
  | ({
      useTradingTerminalOldVersion: boolean;
      setUseTradingTerminalOldVersion: (
        useTradingTerminalOldVersion: boolean
      ) => void;
      isMobile: boolean;
      tab: TradingTerminalTabs;
      setTab: (tab: TradingTerminalTabs) => void;
      createTradeTab: CreateTradeSections;
      setCreateTradeTab: (createTradeTab: CreateTradeSections) => void;
      currentPrice: number | undefined;
      getCreateTradeGeneralDataQuery: QueryStatus<GetCreateTradeGeneralDataResponse>;
      getSignalCreateGeneralDataQuery: QueryStatus<GetSignalCreateGeneralDataResponse>;
      getCreateGeneralDataQuery: QueryStatus<GetCreateSignalOrTradeGeneralDataResponse>;
      getAvailableQuantityQuery: QueryStatus<AvailableQuantityResponse>;
      freeTextCreateTrade: (args: { free_text: string }) => any;
      freeTextCreateTradeLoading: boolean;
      createTrade: (args: CreateTradeRequest) => any;
      createTradeLoading: boolean;
      createSignal: (args: CreateSignalRequest) => any;
      createSignalLoading: boolean;
      isLoading?: boolean;
      isFetching?: boolean;
      isError?: boolean;
      refetchErrorQueries: () => void;
      isSignal: boolean;
      getGroupsDataQuery: QueryStatus<GroupData[]>;
      getAdminSubGroupsStatus: QueryStatus<SubGroup[]>;
    } & TradeFormSetters &
      TradeFormValues &
      AmountData &
      ErrorsData)
  | undefined
>(undefined);
